export default {
  SET_COTACAO(state, payload) {
    if (payload.isCotacaoFeita) {
      const resumoNota = [
        {
          descricao: 'Valor Aduaneiro',
          valorTotalMoeda: payload.resumo.nota.valorAduaneiro,
          valorTotalReais: payload.resumo.nota.valorAduaneiro,
        },
        {
          descricao: 'Tributos (II/IPI/Pis/Cofins)',
          valorTotalMoeda: payload.resumo.nota.tributos,
          valorTotalReais: payload.resumo.nota.tributos,
        },
        {
          descricao: payload.classificacao === 'Encomenda' ? 'Total de ICMS (ICMS + ST)' : 'ICMS Efetivamente Pago',
          valorTotalMoeda: payload.resumo.nota.totalIcmsAndST,
          valorTotalReais: payload.resumo.nota.totalIcmsAndST,
        },
        {
          descricao: 'Despesas',
          valorTotalMoeda: payload.resumo.nota.despesas,
          valorTotalReais: payload.resumo.nota.despesas,
        },
        {
          descricao: payload.classificacao === 'Encomenda' ? 'Total NF de Venda' : 'Total de Desembolso',
          valorTotalMoeda: payload.resumo.nota.totalNotaFiscalVenda,
          valorTotalReais: payload.resumo.nota.totalNotaFiscalVenda,
        },
      ];

      const resumoCreditos = [
        {
          descricao: 'Crédito de IPI',
          valorTotalMoeda: payload.resumo.creditos.ipi,
          valorTotalReais: payload.resumo.creditos.ipi,
        },
        {
          descricao: 'Crédito de ICMS',
          valorTotalMoeda: payload.resumo.creditos.icms,
          valorTotalReais: payload.resumo.creditos.icms,
        },
        {
          descricao: 'Crédito de PIS/COFINS',
          valorTotalMoeda: payload.resumo.creditos.pis + payload.resumo.creditos.cofins,
          valorTotalReais: payload.resumo.creditos.pis + payload.resumo.creditos.cofins,
        },
        {
          descricao: 'Total Líquido',
          valorTotalMoeda: payload.resumo.creditos.totalLiquido,
          valorTotalReais: payload.resumo.creditos.totalLiquido,
        },
      ];

      const objetoSimulacaoRealizada = {
        ...payload,
        resumoNota,
        resumoCreditos,
      };

      state.cotacao = objetoSimulacaoRealizada;
    } else {
      state.cotacao = {
        ...payload,
        resumo: {
          nota: {
            valorAduaneiro: '',
            tributos: '',
            totalIcmsAndST: '',
            despesas: '',
            totalNotaFiscalVenda: '',
          },
          creditos: {
            ipi: '',
            icms: '',
            pis: '',
            cofins: '',
            totalLiquido: '',
          },
        },
      };
    }
  },
  SET_COTACOES(state, payload) {
    state.cotacoes = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
  SET_INVOICES(state, payload) {
    state.invoices = payload;
  },
};
